export default __webpack_public_path__ + "static/media/dropdown.d3c33a29.svg";